/**
 * Csv Schema of TipoOcorrencia
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {TipoOcorrencia} from '@/model/resource/TipoOcorrencia'

export class CsvTipoOcorrenciaSchema extends Schema {
  readonly name = 'CsvTipoOcorrencia'

  readonly fieldSet: FieldSet<TipoOcorrencia> = {
    idOcorrenciaPk: schema => schema.model.idOcorrenciaPk,
    nome: schema => schema.model.nome,
    ativo: schema => Helper.bool(schema.model.ativo),
    ehDevolvida: schema => Helper.bool(schema.model.ehDevolvida),
  }
}
